import React from "react";
import type { AdminStats } from "../AdminsPage";

interface AdminStatsStripProps {
    stats: AdminStats | null;
}

const AdminStatsStrip: React.FC<AdminStatsStripProps> = ({ stats }) => {
    return (
        <div className="flex border-b border-gray-200 shrink-0 overflow-x-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
            {/* Única estadística: Total de Admins */}
            <div className="flex-1 py-3.5 px-6 flex items-center gap-3 bg-white min-w-[180px]">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0 bg-[#4f6df5]/10">
                    <svg width="18" height="18" fill="none" stroke="#4f6df5" strokeWidth="2" viewBox="0 0 24 24">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    </svg>
                </div>
                <div>
                    <div className="font-mono text-lg font-bold text-gray-900">{stats ? stats.totalAdmins : "-"}</div>
                    <div className="text-[11px] text-gray-500 mt-0.5">Total administradores</div>
                </div>
            </div>
        </div>
    );
};

export default AdminStatsStrip;